import { AlertsTooltip } from 'bank-documents/src/components/AlertsTooltip'
import { DOCUMENTS_PATH } from 'commons/constants/routes'
import { CheckMark } from 'ui/components/CheckMark'
import { FrequencyLabel } from 'ui/components/Labels'
import { Link } from 'ui/components/Link'
import { TableActions, TableColumn } from 'ui/components/Table'

import { ContactDocuments } from '../../../../../../types'

type TableProps = {
  onDocumentDelete: (documentData: { id: number; name: string }) => void
  returnUrl: string
}

export const columns = ({ returnUrl, onDocumentDelete }: TableProps): TableColumn<ContactDocuments>[] => [
  {
    title: 'Document Name',
    sortable: true,
    align: 'left',
    key: 'name',
    render: (item) => (
      <Link to="/documents/$documentId" params={{ documentId: item.id.toString() }}>
        {item.name}
      </Link>
    )
  },
  {
    title: 'Internal',
    sortable: true,
    key: 'internal',
    render: ({ internal }) => (internal ? <CheckMark value rounded /> : null)
  },
  {
    title: 'Frequency',
    sortable: true,
    key: 'frequency',
    align: 'left',
    render: ({ frequency }) => <FrequencyLabel name={frequency} />
  },
  {
    title: 'Expiration Date',
    sortable: true,
    align: 'left',
    key: 'expirationDate',
    render: ({ expirationDate }) => expirationDate
  },
  {
    align: 'left',
    title: 'Alerts',
    render: (item) => <AlertsTooltip alerts={item.alerts} id={item.id} />
  },
  {
    title: 'Actions',
    width: '50px',
    render: (item) => (
      <TableActions
        items={[
          {
            type: 'edit',
            url: `${DOCUMENTS_PATH}/${item?.id}/edit?returnUrl=${returnUrl}`
          },
          {
            type: 'delete',
            onClick: () => onDocumentDelete(item)
          }
        ]}
      />
    )
  }
]
